import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appButtonPanel]',
})
export class ButtonPanelDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
